/**
 * Import all front-end JS scripts.
 *
 * Compiles to assets/scripts/theme-scripts.js
 */

/* eslint-disable no-unused-vars */

// Import ES6 modules (recommended)
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
import mainNavigation from './base/main-navigation';
import navState from './base/nav-state';
import parallax from './base/parallax';
import responsiveBackgroundImages from './base/responsive-background-images';
import accordionController from './components/accordionController';
import 'what-input';

accordionController.init();
